import { Button } from '@/components/ui/button';
import { ColumnProps } from '@/components/ui/data-table';
import { QuestionnaireSectionProps } from '@/types/questionnaire';
import { router } from '@inertiajs/react';

export function sectionColumns({
  templateId,
  onEdit,
  onDelete,
}: {
  templateId: number;
  onEdit: (section: QuestionnaireSectionProps) => void;
  onDelete?: (section: QuestionnaireSectionProps) => void;
}): ColumnProps<QuestionnaireSectionProps>[] {
  return [
    { field: 'section_order', header: 'Order' },
    { field: 'section_name', header: 'Section Name' },
    {
      field: 'description',
      header: 'Description',
      render: (section) => (
        <div className="break-words whitespace-normal">
          {section.description}
        </div>
      ),
    },
    { field: 'questions_count', header: '# of Questions' },
    {
      header: 'Actions',
      render: (section) => (
        <div className="flex gap-2">
          <Button
            size={'sm'}
            variant={'link'}
            className="cursor-pointer"
            onClick={() =>
              router.get(
                `/admin/questionnaire_templates/${templateId}/questionnaire_sections?section_id=${section.id}`
              )
            }
          >
            View
          </Button>
          <Button
            size={'sm'}
            variant={'link'}
            className="cursor-pointer"
            onClick={() => onEdit(section)}
          >
            Edit
          </Button>
          <Button
            size="sm"
            variant="link"
            onClick={() => onDelete?.(section)}
            disabled={!onDelete}
            className="text-destructive hover:text-destructive"
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];
}
